import { actions } from './normLaboratory/actions'
import { getters } from './normLaboratory/getters'
import { state } from './normLaboratory/state'
import { mutations } from './normLaboratory/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
